import Css from './Customer.module.css';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Colors } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { Col, Row } from 'react-bootstrap';

export default function CustomerByStatus({ status_active = 0, status_draft = 0, status_hold = 0, status_nonactive = 0 }) {
    const data = {
        labels: ['Online', 'Draft', 'Hold', 'Cancelled'],
        datasets: [
            {
                label: '%',
                data: [status_active, status_draft, status_hold, status_nonactive],
                backgroundColor: [
                    '#A19FFB',
                    '#55D8FE',
                    '#FFDA83',
                    '#FF8373',
                    '#F84B89',
                ],
                borderColor: [
                    '#A19FFB',
                    '#55D8FE',
                    '#FFDA83',
                    '#FF8373',
                    '#F84B89',
                ],
                borderWidth: 1,
                cutout: '30%',
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                display: false
            }
        }
    }

    const textCenter = {
        id: 'textCenter',
        beforeDatasetsDraw(chart, args, pluginOptions) {
            const { ctx, data, chartArea: { left, right, top, bottom, width, height } } = chart;

            ctx.save();
            ctx.font = '22px Prompt';
            ctx.fillStyle = 'black';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText('305', chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y);
            ctx.restore();
        }
    }

    return (
        <div className={Css.Graph_Box + ' shadow'}>
            <div className={Css.Content}>
                <div className={Css.Header}>
                    <h6>Customers by Status</h6>
                </div>
                <div className={Css.Content}>
                    <Row className='pt-4'>
                        <Col>
                            <div style={{ width: '100%' }}>
                                <Doughnut data={data} options={options} width={'100px'} ></Doughnut>
                            </div>
                        </Col>
                        <Col>
                            <Row className='pt-4 mb-3'>
                                <Col className='text-start'>
                                    <i className={"fa-regular fa-circle me-2 " + Css.Color_Purple_01}></i>
                                    Online</Col>
                            </Row>
                            <Row className='mb-3'>
                                <Col className='text-start'>
                                    <i className={"fa-regular fa-circle me-2 " + Css.Color_Blue_03}></i>Draft</Col>

                            </Row>
                            <Row className='mb-3'>
                                <Col className='text-start'>
                                    <i className={"fa-regular fa-circle me-2 " + Css.Color_Orange_03}></i>Hold</Col>

                            </Row>
                            {/* <Row className='mb-3'>
                                <Col className='text-start'>
                                <i className={"fa-regular fa-circle me-2 " + Css.Color_Orange_04}></i>Suspended</Col>

                            </Row>*/}
                            <Row>
                                <Col className='text-start'>
                                    <i className={"fa-regular fa-circle me-2 " + Css.Color_Pink_01}></i>Cancelled</Col>

                            </Row>
                        </Col>
                    </Row>

                </div>
            </div>
        </div>
    )
}